export enum E_AlarmSoundType {
    CONTINUOUS = 'Continuous',
    OFF = 'Off',
    ONSTART = 'OnStart'
}
